// extracted by mini-css-extract-plugin
module.exports = {"listName":"_24BJykY55lJ7k0K6NllQS2","heading":"_2tnwX8PA58OEK1LNYMsjLC","ingress":"_2th30g3gK_W0-ykBymwG6o"};